import "./assets/App.css";
import React from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  useNavigate,
  Navigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import loadable from "@loadable/component";
import Sidebar from "./components/sidebar";
import Header from "./components/header";
import FindMy from "./services/auth";
import Login from "./pages/login";
import AddLocation from "./pages/locations/add";
import EditLocation from "./pages/locations/edit";
import AddVideo from "./pages/videos/add/index";
import EditVideo from "./pages/videos/edit/index";
import CreateUser from "./pages/users/create.js";
import EditUser from "./pages/users/edit";
import CreatePartner from "./pages/partners/add.js";
import EditLoop from "./pages/loops/edit.js";
import LoopPreview from "./pages/loops/preview.js";
import EditCampaign from "./pages/campaigns/edit.js";
import AddCampaign from "./pages/campaigns/add.js";
import CampaignAnalytics from "./pages/campaigns/analytics.js";
import EditPartner from "./pages/partners/edit.js";

const routesList = {
  dashboard: {
    title: "Panou de control",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: true,
      },
    ],
  },
  create_user: {
    title: "Create new user",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "User",
        Link: "/users",
        isActive: false,
      },
      {
        Name: "New user",
        Link: "/users/create",
        Title: "Create new user",
        isActive: true,
      },
    ],
  },
  user: {
    title: "Lista utilizatori",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Utilizatori",
        Link: "/users",
        Title: "Lista utilizatori",
        isActive: true,
      },
    ],
  },
  update_user: {
    title: "Update user",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "User",
        Link: "/users",
        isActive: false,
      },
      {
        Name: "Update user",
        Link: "/users/:id",
        Title: "Update user",
        isActive: true,
      },
    ],
  },
  loops: {
    title: "Playlist",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Playlist",
        Link: "/loops",
        isActive: true,
      },
    ],
  },
  edit_loops: {
    title: "Editeaza playlist",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Playlist",
        Link: "/loops",
        isActive: false,
      },
      {
        Name: "Editeaza playlist",
        Link: "/loops/:id",
        Title: "Editeaza playlist",
        isActive: true,
      },
    ],
  },
  edit_loops_from_campaigns: {
    title: "Editeaza playlist",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Campaigns",
        Link: "/campaigns",
        isActive: false,
      },
      {
        Name: "Editeaza playlist",
        Link: "/loops/:id",
        Title: "Editeaza playlist",
        isActive: true,
      },
    ],
  },
  edit_loops_from_devices: {
    title: "Editeaza playlist",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Devices",
        Link: "/devices",
        isActive: false,
      },
      {
        Name: "Editeaza playlist",
        Link: "/loops/:id",
        Title: "Editeaza playlist",
        isActive: true,
      },
    ],
  },
  preview_loops: {
    title: "Create Playlist",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Playlist",
        Link: "/loops",
        isActive: false,
      },
      {
        Name: "Create Playlist",
        Link: "/loops/preview",
        Title: "Create Playlist",
        isActive: true,
      },
    ],
  },
  campaigns: {
    title: "Campanii",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Campanii",
        Link: "/campaigns",
        isActive: true,
      },
    ],
  },
  edit_campaign: {
    title: "Vezi detalii",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Campanii",
        Link: "/campaigns",
        isActive: false,
      },
      {
        Name: "Vezi detalii",
        Link: "/campaigns/:id",
        Title: "Vezi detalii",
        isActive: true,
      },
    ],
  },
  add_campaign: {
    title: "Creeaza o noua campanie",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Campanii",
        Link: "/campaigns",
        isActive: false,
      },
      {
        Name: "Creeaza o noua campanie",
        Link: "/campaigns/add",
        Title: "Creeaza o noua campanie",
        isActive: true,
      },
    ],
  },
  analytics_campaign: {
    title: "Raport campanie",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Campanii",
        Link: "/campaigns",
        isActive: false,
      },
      {
        Name: "Raport campanie",
        Link: "/campaigns/:id/analytics",
        Title: "Raport campanie",
        isActive: true,
      },
    ],
  },
  devices: {
    title: "Lista Playere",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista Playere",
        Link: "/devices",
        isActive: true,
      },
    ],
  },
  videos: {
    title: "Lista spoturi",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista spoturi",
        Link: "/videos",
        isActive: true,
      },
    ],
  },
  create_video: {
    title: "Adauga spot",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista spoturi",
        Link: "/videos",
        isActive: false,
      },
      {
        Name: "Adauga spot",
        Link: "/videos/create",
        Title: "Adauga spot",
        isActive: true,
      },
    ],
  },
  edit_video: {
    title: "Editeaza spot",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista spoturi",
        Link: "/videos",
        isActive: false,
      },
      {
        Name: "Editeaza spot",
        Link: "/videos/:id",
        Title: "Editeaza spot",
        isActive: true,
      },
    ],
  },
  category: {
    title: "Lista categorii",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista categorii",
        Link: "/category",
        isActive: true,
      },
    ],
  },
  locations: {
    title: "Lista locatii",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista locatii",
        Link: "/locations",
        isActive: true,
      },
    ],
  },
  create_location: {
    title: "Creeaza o noua locatie",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista locatii",
        Link: "/locations",
        isActive: false,
      },
      {
        Name: "Creeaza o noua locatie",
        Link: "/locations/create",
        Title: "Creeaza o noua locatie",
        isActive: true,
      },
    ],
  },
  edit_location: {
    title: "Editeaza locatia",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista locatii",
        Link: "/locations",
        isActive: false,
      },
      {
        Name: "Editeaza locatia",
        Link: "/locations/:id",
        Title: "Creeaza o noua locatie",
        isActive: true,
      },
    ],
  },
  logs: {
    title: "Logs",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Logs",
        Link: "/logs",
        isActive: true,
      },
    ],
  },
  partners: {
    title: "Parteneri",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Parteneri",
        Link: "/partners",
        isActive: true,
      },
    ],
  },
  locations_from_partner: {
    title: "Lista locatii",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Parteneri",
        Link: "/partners",
        isActive: false,
      },
      {
        Name: "Lista locatii",
        Link: "/locations",
        isActive: true,
      },
    ],
  },
  create_partner: {
    title: "Creeaza partener",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista parteneri",
        Link: "/partners",
        isActive: false,
      },
      {
        Name: "Creeaza partener",
        Link: "/partners/create",
        isActive: true,
      },
    ],
  },
  edit_partner: {
    title: "Editeaza partener",
    list: [
      {
        Name: "Panou de control",
        Link: "/",
        isActive: false,
      },
      {
        Name: "Lista parteneri",
        Link: "/partners",
        isActive: false,
      },
      {
        Name: "Editeaza partener",
        Link: "/partners/:id",
        isActive: true,
      },
    ],
  },
};

const Dashboard = loadable(() => import("./pages/dashboard"));
const User = loadable(() => import("./pages/users"));
const Category = loadable(() => import("./pages/category"));
const Devices = loadable(() => import("./pages/devices"));
const Videos = loadable(() => import("./pages/videos"));
const Locations = loadable(() => import("./pages/locations"));
const Logs = loadable(() => import("./pages/settings/logs"));
const Partners = loadable(() => import("./pages/partners"));
const Loops = loadable(() => import("./pages/loops"));
const Campaigns = loadable(() => import("./pages/campaigns/index.js"));

function RequireAuth({ children, isLogged, info, pathName }) {
  const [searchParams] = useSearchParams();
  const navigator = useNavigate();
  const location = useLocation();
  const [canGoBack, setCanGoBack] = React.useState(false);

  React.useEffect(() => {
    const hasNavigationHistory =
      location.key !== "default" && window.history.length > 1;
    setCanGoBack(hasNavigationHistory);
  }, [location]);

  // Ensure we're reading the query parameter correctly
  const fromCampaigns = searchParams.get("from") === "campaigns";
  const fromDevices = searchParams.get("from") === "devices";
  const partnerParam = searchParams.get("partner");

  // If user came from campaigns, change pathName dynamically
  if (fromCampaigns && pathName === "edit_loops") {
    pathName = "edit_loops_from_campaigns";
  }

  if (fromDevices && pathName === "edit_loops") {
    pathName = "edit_loops_from_devices";
  }

  // If user is on locations with partner parameter, change pathName dynamically
  if (partnerParam && pathName === "locations") {
    pathName = "locations_from_partner";
  }

  if (!routesList[pathName]) {
    console.error(`Invalid pathName: ${pathName}`);
    return <Navigate to={"/"} />;
  }

  return isLogged ? (
    <>
      <Header info={info} />
      <div>
        <Sidebar info={info} />
        <div className="page-wrapper">
          <div className="route">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                marginTop: 10,
              }}
            >
              {canGoBack && (
                <button
                  onClick={() => navigator(-1)}
                  style={{
                    marginTop: -5,
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    border: "2px solid #ddd",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    boxShadow: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#666",
                    transition: "all 0.2s ease",
                    outline: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f8f9fa";
                    e.target.style.borderColor = "#000";
                    e.target.style.color = "#000";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.borderColor = "#ddd";
                    e.target.style.color = "#666";
                    e.target.style.transform = "translateY(0)";
                  }}
                  title="Inapoi"
                >
                  ⬅
                </button>
              )}
              <div className="header-default">{routesList[pathName].title}</div>
            </div>
            {routesList[pathName].list.map((route, key) => {
              return (
                <span
                  key={key}
                  onClick={() =>
                    route.isActive === false ? navigator(route.Link) : null
                  }
                >
                  <span
                    className={
                      route.isActive ? "header-active" : "header-inactive"
                    }
                  >
                    {route.Name}
                  </span>
                  {key !== routesList[pathName].list.length - 1 && (
                    <span
                      style={{
                        marginInline: 15,
                        color: "rgba(35,43,53, 0.5)",
                      }}
                    >
                      •
                    </span>
                  )}
                </span>
              );
            })}
          </div>
          <div className="content container-fluid">{children}</div>
        </div>
      </div>
    </>
  ) : (
    <Navigate to={"/login"} />
  );
}

const App = () => {
  const [isLogged, setIsLogged] = React.useState(null);
  const [info, setInfo] = React.useState(null);

  async function isUserAuthenticated() {
    const content = await FindMy();
    if (content.status === "ok") {
      setIsLogged(true);
      setInfo(content.data);
    } else {
      localStorage.removeItem("token");
      setIsLogged(false);
      setInfo(null);
    }
  }

  React.useEffect(() => {
    isUserAuthenticated();
  }, []);

  const checkPermission = (param) => {
    if (info && info.role.includes("ROLE_ADMIN")) {
      return true;
    }
    return false;
  };

  if (isLogged === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="main-wrapper">
      <BrowserRouter>
        <Routes>
          {/* dashboard start */}
          <Route
            path="/"
            element={
              <RequireAuth
                pathName={"dashboard"}
                isLogged={isLogged}
                info={info}
              >
                <Dashboard info={info}></Dashboard>
              </RequireAuth>
            }
          />
          {/* dashboard end */}
          {/* users start */}
          {checkPermission() && (
            <>
              <Route
                path="/users"
                element={
                  <RequireAuth
                    isLogged={isLogged}
                    info={info}
                    pathName={"user"}
                  >
                    <User />
                  </RequireAuth>
                }
              />

              <Route
                path="/users/create"
                element={
                  <RequireAuth
                    isLogged={isLogged}
                    info={info}
                    pathName={"create_user"}
                  >
                    <CreateUser />
                  </RequireAuth>
                }
              />

              <Route
                path="/users/:id"
                element={
                  <RequireAuth
                    isLogged={isLogged}
                    info={info}
                    pathName={"update_user"}
                  >
                    <EditUser />
                  </RequireAuth>
                }
              />
            </>
          )}

          {/* <Route
            path="/loops"
            element={
              <RequireAuth isLogged={isLogged} info={info} pathName={"loops"}>
                <Loops />
              </RequireAuth>
            }
          /> */}
          <Route
            path="/loops/:id"
            element={
              <RequireAuth
                isLogged={isLogged}
                info={info}
                pathName={"edit_loops"}
              >
                <EditLoop />
              </RequireAuth>
            }
          />
          <Route
            path="/loops/preview"
            element={
              <RequireAuth
                isLogged={isLogged}
                info={info}
                pathName={"preview_loops"}
              >
                <LoopPreview />
              </RequireAuth>
            }
          />
          <Route
            path="/campaigns"
            element={
              <RequireAuth
                isLogged={isLogged}
                info={info}
                pathName={"campaigns"}
              >
                <Campaigns />
              </RequireAuth>
            }
          />
          <Route
            path="/campaigns/:id"
            element={
              <RequireAuth
                isLogged={isLogged}
                info={info}
                pathName={"edit_campaign"}
              >
                <EditCampaign />
              </RequireAuth>
            }
          />
          <Route
            path="/campaigns/add"
            element={
              <RequireAuth
                isLogged={isLogged}
                info={info}
                pathName={"add_campaign"}
              >
                <AddCampaign />
              </RequireAuth>
            }
          />
          <Route
            path="/campaigns/:id/analytics"
            element={
              <RequireAuth
                isLogged={isLogged}
                info={info}
                pathName={"analytics_campaign"}
              >
                <CampaignAnalytics />
              </RequireAuth>
            }
          />
          {/* users end */}
          {/* category start */}
          <Route
            path="/category"
            element={
              <RequireAuth
                pathName={"category"}
                isLogged={isLogged}
                info={info}
              >
                <Category></Category>
              </RequireAuth>
            }
          />
          {/* category end */}
          {/* partners start */}
          <Route
            path="/partners"
            element={
              <RequireAuth
                pathName={"partners"}
                isLogged={isLogged}
                info={info}
              >
                <Partners></Partners>
              </RequireAuth>
            }
          />
          <Route
            path="/partners/create"
            element={
              <RequireAuth
                pathName={"create_partner"}
                isLogged={isLogged}
                info={info}
              >
                <CreatePartner></CreatePartner>
              </RequireAuth>
            }
          />
          <Route
            path="/partners/:id"
            element={
              <RequireAuth
                pathName={"edit_partner"}
                isLogged={isLogged}
                info={info}
              >
                <EditPartner></EditPartner>
              </RequireAuth>
            }
          />
          {/* partners end */}
          {/* devices start */}
          <Route
            path="/devices"
            element={
              <RequireAuth pathName={"devices"} isLogged={isLogged} info={info}>
                <Devices></Devices>
              </RequireAuth>
            }
          />
          {/* devices end */}
          {/* videos start */}
          <Route
            path="/videos"
            element={
              <RequireAuth pathName={"videos"} isLogged={isLogged} info={info}>
                <Videos />
              </RequireAuth>
            }
          />
          <Route
            path="/videos/create"
            element={
              <RequireAuth
                pathName={"create_video"}
                isLogged={isLogged}
                info={info}
              >
                <AddVideo />
              </RequireAuth>
            }
          />
          <Route
            path="/videos/:id"
            element={
              <RequireAuth
                pathName={"edit_video"}
                isLogged={isLogged}
                info={info}
              >
                <EditVideo />
              </RequireAuth>
            }
          />
          {/* videos end */}
          {/* locations start */}
          <Route
            path="/locations"
            element={
              <RequireAuth
                pathName={"locations"}
                isLogged={isLogged}
                info={info}
              >
                <Locations></Locations>
              </RequireAuth>
            }
          />
          <Route
            path="/locations/create"
            element={
              <RequireAuth
                pathName={"create_location"}
                isLogged={isLogged}
                info={info}
              >
                <AddLocation></AddLocation>
              </RequireAuth>
            }
          />
          <Route
            path="/locations/:id"
            element={
              <RequireAuth
                pathName={"edit_location"}
                isLogged={isLogged}
                info={info}
              >
                <EditLocation></EditLocation>
              </RequireAuth>
            }
          />
          {/* locations end */}
          {/* settings start */}
          {checkPermission() && (
            <>
              <Route
                path="/logs"
                element={
                  <RequireAuth
                    pathName={"logs"}
                    isLogged={isLogged}
                    info={info}
                  >
                    <Logs info={info}></Logs>
                  </RequireAuth>
                }
              />
            </>
          )}

          {/* settings end */}
          <Route path="/login" element={<Login />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
